import type { DuplicateProfileGroup } from "./types";

export function makeDuplicateProfileGroup(json: any): DuplicateProfileGroup {
  return {
    documentIds: json.document_ids ?? [],
    displayName: json.display_name ?? "",
  };
}

export function makeDuplicateProfileGroups(json: any): DuplicateProfileGroup[] {
  return json?.map(makeDuplicateProfileGroup) ?? [];
}
